import {
  Activity,
  ArchiveX,
  BookOpen,
  Bot,
  FileDiff,
  FlaskConical,
  GitPullRequestArrow,
  Hash,
  Lock,
  Route,
  Smartphone,
  SplitSquareHorizontal,
  Tags,
  ArrowRightLeft,
  AudioWaveform,
  BarChart3,
  BookMarked,
  Braces,
  Building2,
  Code2,
  CreditCard,
  FileCode2,
  FilePlus2,
  Film,
  Fingerprint,
  Gavel,
  HardDrive,
  Handshake,
  Headset,
  Image,
  Instagram,
  KeyRound,
  LayoutDashboard,
  Library,
  LifeBuoy,
  LineChart,
  Link2,
  ListChecks,
  ListMusic,
  Megaphone,
  Music2,
  MessageCircleQuestion,
  MicVocal,
  Palette,
  Radio,
  Receipt,
  Scale,
  SquareCode,
  UserCheck,
  Wallet,
  Webhook,
  Wrench,
  type LucideIcon,
} from 'lucide-react'

/* One icon per capability in TechnologyContent::MODULES.
 *
 * Keyed by the module KEY rather than by name or position, so renaming a
 * capability in Ruby never silently swaps its icon for a neighbour's.
 *
 * Why bother: these sub-pages list up to fourteen capabilities each, and an
 * unbroken column of paragraphs is the exact shape a reader skims past. The
 * icon is a scanning aid — it gives the eye somewhere to land and makes the
 * list feel like a system rather than a document.
 *
 * `iconFor` falls back rather than throwing. A module added in Ruby without an
 * icon here should render a slightly duller card, not take the whole marketing
 * page down — the copy is the payload, the icon is the garnish.
 */
const MODULE_ICONS: Record<string, LucideIcon> = {
  // Distribution
  catalog: Library,
  'release-builder': FilePlus2,
  delivery: Radio,
  'supply-agnostic': Handshake,
  rights: Scale,
  royalties: Receipt,
  payouts: Wallet,
  analytics: BarChart3,
  accounts: Building2,
  billing: CreditCard,
  support: LifeBuoy,
  storage: HardDrive,
  migration: ArrowRightLeft,
  'partner-delivery': Route,
  'identifier-ranges': Hash,
  'two-stage-review': GitPullRequestArrow,
  'release-lifecycle': Lock,
  takedowns: ArchiveX,
  adjustments: FileDiff,
  'royalty-splits': SplitSquareHorizontal,
  publishing: BookMarked,
  'publishing-metadata': Music2,

  // Release QC
  'qc-metadata': ListChecks,
  'qc-artwork': Image,
  'qc-audio': AudioWaveform,
  'qc-matching': Fingerprint,
  'qc-clarify': MessageCircleQuestion,
  'qc-verdict': Gavel,
  'qc-api': Webhook,
  'qc-embed': SquareCode,
  'audio-intelligence': Activity,

  // Creative & audience
  'artwork-studio': Palette,
  'lyrics-studio': MicVocal,
  'video-generation': Film,
  lnkbee: Link2,
  'social-kits': Instagram,
  pitching: Megaphone,
  tracking: LineChart,
  'playlist-engine': ListMusic,

  // API & branded platform
  'rest-api': Code2,
  'api-keys': KeyRound,
  'branded-platform': Palette,
  'end-user-identity': UserCheck,
  'delivery-agent': Bot,
  'artist-billing': CreditCard,
  'label-requests': Tags,
  'test-period': FlaskConical,
  'console-help': BookOpen,
  'mobile-app': Smartphone,
  'console-api-docs': BookMarked,

  // Managed services
  'managed-onboarding': ArrowRightLeft,
  'managed-metadata': ListChecks,
  'managed-delivery': Radio,
  'managed-royalties': Receipt,
  'managed-support': Headset,
  'managed-dashboard': LayoutDashboard,
  'custom-development': Wrench,
  webhooks: Webhook,
  'typed-clients': Braces,
  ddex: FileCode2,
}

export function iconFor(key: string): LucideIcon {
  return MODULE_ICONS[key] ?? LayoutDashboard
}
